export const tr = {
    'action-add': 'ekle',
    'action-cancel': 'iptal',
    'error-text': 'Ürün adı sadece Latin harfleri ve  "-" ile  "_" karakterlerini içerebilir.',
    'product-description-label': 'ürün açıklaması',
    'product-name-label': 'ürün adı'
};
